export namespace RankGroupId {
  export const Iron = 1n;
  export const Bronze = 2n;
  export const Silver = 3n;
  export const Gold = 4n;
  export const Ruby = 5n;
  export const Esmerald = 6n;
  export const Diamond = 7n;
  export const DiamondII = 8n;
  export const DiamondIII = 9n;
}

export type RankGroupType = (typeof RankGroupId)[keyof typeof RankGroupId];
